import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HeaderBack from "../../../../helbest/HeaderBack/HeaderBack";
import styles from "./ServicesDetails.module.css";
import { Note, Page } from "../../../../helbest";
import { API } from "../../../../request/api";

import { ReactComponent as Verify } from "../../../../assets/svg/verify.svg";
import { ReactComponent as UnVerify } from "../../../../assets/svg/unverify.svg";
import { ReactComponent as Trash } from "../../../../assets/svg/trash.svg";
import { Modal } from "antd";
import Loading from "../../../components/Loading/Loading";
import { convertUTCToLocalTime } from "../../../../base/utils";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

const ServicesDetails = () => {
  const [loading, set_loading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [serviceDetailList, setServiceDetailList] = useState(null);
  const { id } = useParams();
  const navigate = useLangNavigate();
  const { t, i18n } = useTranslation();

  const deleteService = () => {
    setDeleting(true);
    API.del
      .deleteServiceDetails(id)
      .then((response) => {
        if (response.success) {
          setIsModalOpen(false);
          navigate("/appointment?tab=SERVICES", {
            replace: true,
          });
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        setDeleting(false);
      });
  };

  const services = () => {
    set_loading(true);
    API.get
      .getServiceDetails(id)
      .then((response) => {
        if (response.success) {
          setServiceDetailList(response.data);
          set_loading(false);
        } else {
          Note.error(response.message);
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  useEffect(() => {
    services();
  }, []);

  return (
    <Page
      bodyWrapperClassName={styles.ServicePage}
      back={true}
      customHeader={<HeaderBack title={t("service_details.title")} />}
      headerFix
    >
      {loading ? (
        <div className={styles.Loading}>
          <Loading />
        </div>
      ) : !!serviceDetailList ? (
        <div className="mt-4">
          {serviceDetailList.is_verified ? (
            <div className={styles.verify}>
              <Verify className={styles.icon} /> {t("service_details.verified")}
              !
            </div>
          ) : (
            <div className={styles.unVerify}>
              <UnVerify className={styles.icon} />{" "}
              {t("service_details.unverified")}!
            </div>
          )}
          <>
            <div className={styles.DetailCardContainer}>
              <div className={styles.line}>
                <span className={styles.Date}>
                  {serviceDetailList.created_at.replaceAll("-", "/")} -{" "}
                  {serviceDetailList.created_time &&
                    convertUTCToLocalTime(
                      serviceDetailList.created_time?.substring(0, 5)
                    )}
                </span>
                {!serviceDetailList.is_verified && (
                  <Trash
                    className={styles.Trash}
                    onClick={() => setIsModalOpen(true)}
                    height={25}
                    width={25}
                  />
                )}
              </div>
              <div
                className={`${styles.box} ${
                  i18n.dir() === "rtl" ? styles.rtl : ""
                }`}
              >
                <div>{t("common.id_number")}</div>
                <div>{serviceDetailList.id}</div>
                <div>{t("appointment.customer_name")}</div>
                <div>{serviceDetailList.customer.fullname}</div>
                <div>{t("appointment.customer_phone")}</div>
                <div>{serviceDetailList.customer.mobile}</div>
                <div>{t("services.car_model")}</div>
                <div>{serviceDetailList.car}</div>
                <div>{t("service_details.odometer_value")}</div>
                <div>{serviceDetailList.current_kilometer}km</div>
                <div>{t("services.total_charge_price")}</div>
                <div className={styles.chargePrice}>
                  <span>OMR</span>
                  <span>{serviceDetailList.total_charge_price}</span>
                </div>
              </div>
              <div className={styles.productsHeader}>
                <span>{t("common.products")}</span>
              </div>
              <div className={styles.productsContainer}>
                {serviceDetailList.items?.map((item, i) => (
                  <div
                    className={`${styles.box} ${
                      i18n.dir() === "rtl" ? styles.rtl : ""
                    }`}
                    key={i}
                  >
                    <div>{t("service_details.product_name")}</div>
                    <div>{item.product}</div>
                    <div>{t("cart.quantity")}</div>
                    <div>{item.quantity}</div>
                    <div>{t("common.charge_price")}</div>
                    <div>{item.charge_price}</div>
                  </div>
                ))}
              </div>
            </div>
          </>
        </div>
      ) : null}
      <Modal
        open={isModalOpen}
        title={t("service_details.delete_modal_title")}
        closable={false}
        centered
        cancelText={t("common.cancel")}
        okText={t("common.delete")}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => deleteService()}
        cancelButtonProps={{
          type: "primary",
          ghost: true,
        }}
        okButtonProps={{
          loading: deleting,
          type: "primary",
          danger: true,
        }}
      />
    </Page>
  );
};

export default ServicesDetails;
